module.exports = __webpack_public_path__ + "media/images/svg/chevron-up-459f4ca673c2f6f2b2f9e6652829f711.svg";